/**
 * Central de Importação - Sistema > Central de Importação
 * Fluxo: 1) Selecionar entidade, 2) Upload e validação, 3) Importação
 * Layout alinhado ao sistema (msgbox, form, variáveis CSS)
 */
import api from '../api.js';

const CATEGORIAS = {
	organização: 'Organização',
	catálogo: 'Catálogo',
	armazenamento: 'Armazenamento',
};

let entities = {};
let selectedEntity = null;
let validationResult = null;

function $(sel, ctx = document) {
	return ctx.querySelector(sel);
}

function renderEntitySelector(container) {
	const groups = {};
	for (const [key, schema] of Object.entries(entities)) {
		const cat = schema.category || 'outros';
		if (!groups[cat]) groups[cat] = [];
		groups[cat].push({ key, ...schema });
	}
	const order = ['organização', 'catálogo', 'armazenamento'];
	let html = '<div class="import-entity-list">';
	for (const cat of order) {
		if (!groups[cat]) continue;
		html += `<div class="import-category mtm">`;
		html += `<div class="import-cat-title">${CATEGORIAS[cat] || cat}</div>`;
		html += '<div class="import-cat-items">';
		for (const e of groups[cat]) {
			html += `<button type="button" data-entity="${e.key}" class="import-entity-btn button">${e.label}</button>`;
		}
		html += '</div></div>';
	}
	html += '</div>';
	container.innerHTML = html;
}

function renderStep1(container) {
	container.innerHTML = `
		<div class="msgbox import-step" data-step="1">
			<div class="title">Central de Importação</div>
			<p class="mts">Selecione o tipo de cadastro para importar:</p>
			<div id="import-entity-list"></div>
		</div>`;
	renderEntitySelector($('#import-entity-list', container));
}

function renderStep2(container, entityKey) {
	const schema = entities[entityKey];
	const cols = (schema?.cols || []).join(', ');
	container.innerHTML = `
		<div class="form import-step" data-step="2">
			<div class="title">Importar ${schema?.label || entityKey}</div>
			<p class="mts">Colunas esperadas: <strong>${cols}</strong></p>
			<div class="mtl fsb">
				<label>Arquivo (CSV ou XLSX)<sup>*</sup>
					<input id="import-file" type="file" accept=".csv,.xlsx" required>
				</label>
			</div>
			<div class="mtm">
				<a id="import-download-template" href="#" class="link">Baixar modelo da planilha</a>
			</div>
			<div class="mtm fsb">
				<button type="button" id="import-back" class="button bn_Escape">Voltar</button>
				<button type="button" id="import-validate" class="button bn_Enter">Validar</button>
			</div>
		</div>`;
}

function renderStep3(container, result) {
	const ok = result?.ok === true;
	const errors = result?.errors || [];
	const rowsValid = result?.rows_valid || [];
	const total = result?.total || 0;

	let errorsHtml = '';
	if (errors.length > 0) {
		errorsHtml = '<div class="import-errors mtm"><strong>Problemas encontrados:</strong><ul>';
		for (const e of errors.slice(0, 20)) {
			errorsHtml += `<li>Linha ${e.linha}: ${e.campo ? e.campo + ' – ' : ''}${e.mensagem}</li>`;
		}
		if (errors.length > 20) {
			errorsHtml += `<li>... e mais ${errors.length - 20} erro(s)</li>`;
		}
		errorsHtml += '</ul></div>';
	}

	let successHtml = '';
	if (ok && rowsValid.length > 0) {
		successHtml = `<div class="import-success mts"><strong>Validação OK.</strong> ${rowsValid.length} de ${total} linha(s) prontas para importar.</div>`;
	} else if (ok && rowsValid.length === 0) {
		successHtml = '<div class="import-warning mts">Nenhuma linha válida encontrada.</div>';
	}

	container.innerHTML = `
		<div class="msgbox import-step" data-step="3">
			<div class="title">Resultado da validação</div>
			${successHtml}
			${errorsHtml}
			<div class="mtm fsb">
				<button type="button" id="import-back2" class="button bn_Escape">Voltar</button>
				${ok && rowsValid.length > 0 ? '<button type="button" id="import-do" class="button bn_Enter">Importar</button>' : ''}
			</div>
		</div>`;
}

function renderStep4(container, result) {
	const imported = result?.imported || 0;
	const failed = result?.failed || [];
	let failedHtml = '';
	if (failed.length > 0) {
		failedHtml = '<div class="import-errors mtm"><strong>Falhas:</strong><ul>';
		for (const f of failed.slice(0, 10)) {
			failedHtml += `<li>Linha ${f.linha}: ${f.mensagem}</li>`;
		}
		if (failed.length > 10) {
			failedHtml += `<li>... e mais ${failed.length - 10}</li>`;
		}
		failedHtml += '</ul></div>';
	}
	container.innerHTML = `
		<div class="msgbox import-step" data-step="4">
			<div class="title">Importação concluída</div>
			<div class="import-success mts"><strong>${imported}</strong> registro(s) importado(s) com sucesso.</div>
			${failedHtml}
			<div class="mtm">
				<button type="button" id="import-new" class="button bn_Enter">Nova importação</button>
			</div>
		</div>`;
}

async function loadEntities() {
	const r = await api.import_center_entities();
	if (!r.ok) throw new Error('Erro ao carregar entidades');
	entities = await r.json();
}

async function downloadTemplate(entityKey) {
	const r = await api.import_center_template(entityKey);
	if (!r.ok) throw new Error('Erro ao baixar modelo');
	const blob = await r.blob();
	const a = document.createElement('a');
	a.href = URL.createObjectURL(blob);
	a.download = `modelo_${entityKey}.csv`;
	a.click();
	URL.revokeObjectURL(a.href);
}

async function validate(entityKey, file) {
	const fd = new FormData();
	fd.append('entity_key', entityKey);
	fd.append('file', file);
	const r = await api.import_center_validate(fd);
	if (!r.ok) {
		const text = await r.text();
		throw new Error(text || 'Erro na validação');
	}
	return r.json();
}

async function doImport(entityKey, rowsValid) {
	const r = await api.import_center_import({ entity_key: entityKey, rows_valid: rowsValid });
	if (!r.ok) {
		const text = await r.text();
		throw new Error(text || 'Erro na importação');
	}
	return r.json();
}

function showError(msg) {
	alert(msg);
}

const import_center = async function() {
	const workarea = document.getElementById('workarea');
	if (!workarea) return;

	const styles = `
		#import-center-wrap {
			display: flex;
			justify-content: center;
			align-items: flex-start;
			padding: var(--space-lg);
			min-height: 100%;
			background-color: var(--color-secondary);
		}
		#import-center { max-width: 42rem; width: 100%; }
		#import-center .import-cat-title {
			font-weight: 600;
			margin-bottom: var(--space-sm);
			color: var(--color-text);
		}
		#import-center .import-cat-items {
			display: flex;
			flex-wrap: wrap;
			gap: var(--space-sm);
		}
		#import-center .import-entity-btn {
			display: inline-block;
			text-align: center;
			margin: 0;
			text-decoration: none;
		}
		#import-center .import-errors {
			color: var(--color-error);
			padding: var(--space-sm);
			background-color: var(--color-secondary);
			border: 1px solid var(--color-border);
			border-radius: 4px;
		}
		#import-center .import-errors ul { margin: var(--space-sm) 0 0; padding-left: var(--space-lg); }
		#import-center .import-success {
			color: #0a6b0a;
			padding: var(--space-sm);
			background-color: #f0f9f0;
			border: 1px solid #c8e6c8;
			border-radius: 4px;
		}
		#import-center .import-warning {
			color: #8a6d00;
			padding: var(--space-sm);
			background-color: #fffbe6;
			border: 1px solid #e6d68a;
			border-radius: 4px;
		}
	`;

	workarea.innerHTML = `<style>${styles}</style><div id="import-center-wrap"><div id="import-center"></div></div>`;
	const container = $('#import-center');

	try {
		await loadEntities();
	} catch (e) {
		showError(e.message);
		return;
	}

	container.addEventListener('click', async (ev) => {
		const entityBtn = ev.target.closest('.import-entity-btn');
		if (entityBtn) {
			ev.preventDefault();
			selectedEntity = entityBtn.dataset.entity;
			renderStep2(container, selectedEntity);
			$('#import-file').value = '';
			return;
		}

		if (ev.target.id === 'import-download-template') {
			ev.preventDefault();
			try {
				await downloadTemplate(selectedEntity);
			} catch (e) {
				showError(e.message);
			}
			return;
		}

		if (ev.target.id === 'import-back' || ev.target.id === 'import-back2') {
			renderStep1(container);
			selectedEntity = null;
			validationResult = null;
			return;
		}

		if (ev.target.id === 'import-validate') {
			const fileInput = $('#import-file');
			const file = fileInput?.files?.[0];
			if (!file) {
				showError('Selecione um arquivo.');
				return;
			}
			try {
				validationResult = await validate(selectedEntity, file);
				renderStep3(container, validationResult);
			} catch (e) {
				showError(e.message);
			}
			return;
		}

		if (ev.target.id === 'import-do') {
			const rows = validationResult?.rows_valid || [];
			if (rows.length === 0) return;
			try {
				const result = await doImport(selectedEntity, rows);
				renderStep4(container, result);
			} catch (e) {
				showError(e.message);
			}
			return;
		}

		if (ev.target.id === 'import-new') {
			renderStep1(container);
			selectedEntity = null;
			validationResult = null;
			return;
		}
	});

	renderStep1(container);
};

export default import_center;
